export const AIRPORT = "Airport"
export const TERMINALS = "Terminals"
export const OPERATION_TYPE = "OperationType"
export const CURRENT_LANGUAGE = "CurrentLanguage"
export const TRANSPORT_INFO = "TransportInfo"
export const SERVICE_TYPES = "ServiceTypes"
export const ACCESS_TOKEN = "AccessToken"
export const LOGIN_TYPE = "LoginType"
export const FILTER = "Filter"
export const PRELOAD_FILTERS = "PreloadFilters"
export const SECTION_SELECTED_DEPARTURES = "sectionSelectedDepartures"
export const SECTION_SELECTED_CONTROLLER = "sectionSelectedController"
export const SELECTED_TRAFFIC_TAB = "TrafficTab"
export const IS_FILTER_ACTIVE = "isFilterActive"
export const OPERATION_BUTTON_TEXT = "operationButtonText"
export const AREA_BUTTON_TEXT = "areaButtonText"
export const CONFIRM_VERSION = "confirm_version"
export const STORAGE_NOTIFICATION = "storage_notification"